import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface KeywordCluster {
  topic: string
  keywords: string[]
  intent: 'informational' | 'transactional' | 'navigational' | 'commercial'
}

export interface ClusterResponse {
  available: boolean
  clusters: KeywordCluster[]
}

export function useClusterKeywords(siteId: string) {
  return useMutation({
    mutationFn: (keywords: string[]) =>
      apiClient.post<ClusterResponse>(`/api/sites/${siteId}/labs/cluster-keywords`, { keywords }),
  })
}
